import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormAction } from '@app-reports/models/reports.model';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
@Component({
  selector: 'app-scheduled-report',
  templateUrl: './scheduled-report.component.html',
  styleUrls: ['./scheduled-report.component.scss'],
})
export class ScheduledReportComponent {
  constructor(private router: Router, private mixpanelService: MixPanelService) {}

  navigateToCreateSchedule() {
    this.router.navigate(['/reports/create-schedule'], {
      queryParams: {
        action: FormAction.Create,
      },
    });
    this.mixpanelService.track('Create Schedule in Empty state Clicked');
  }
}
